<div class="holder">
    <div class="mapselector search-bar" [class.expanded]="viewState.search">
        <div class="p-4 pb-0">
            <h3>Zoek naar projecten</h3>
            <div class="search-input">
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Zoeken</mat-label>
                    <input id="ttmSearchInput" [formControl]="fcSearch" matInput placeholder="Zoeken...">
                    @if (fcSearch.value) {
                        <mat-icon (click)="fcSearch.reset()" matRipple matSuffix
                                  class="fa-solid fa-xmark"></mat-icon>
                    } @else {
                        <mat-icon matSuffix class="fa-solid fa-magnifying-glass"></mat-icon>
                    }
                </mat-form-field>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="search-list p-4 pt-0">

            <div class="result-text" *ngIf="projects?.length || fcSearch.value">
                {{projects?.length > 0 ? projects?.length : 'Geen'}} Resultaten
            </div>
            @for (project of projects; track project.id) {
                <div matRipple class="search-item" (click)="openProject(project)">
                    <div class="info">
                        <div class="w-100">
                            <div class="d-flex justify-content-between">
                                {{project.name}}
                                <small>
                                    {{project.id_4ps}}
                                </small>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-chip class="mt-1">
                                    {{project.updated_at | date : 'EE d MMM \'\'yy H:mm'}}
                                </mat-chip>
                                <small matTooltip="Dit project bestaat uit {{project.ttms_count}} maatregelen waarvan {{project.ttms_mutated_count}} gemuteerd" [class.text-danger]="project.ttms_count === 0">
                                    <i class="fa fa-location-dot me-1"></i> {{project.ttms_mutated_count}} / {{project.ttms_count}}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
        </div>
    </div>

    <google-map
        height="100vh"
        width="100%"
        #googleMap
        [options]="options">
        <div class="controls-left">
            <div (click)="logout()" tabindex="1" matTooltip="Uitloggen" matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <div (click)="toggleSearchBar()" [class.active]="viewState.search" tabindex="2" matTooltip="Zoeken" matTooltipPosition="after">
                @if (viewState.search) {
                    <i class="fa-solid fa-xmark"></i>
                } @else {
                    <i class="fa fa-search"></i>
                }
            </div>
            <div routerLink="/{{Routenames.TtmTickets}}" *ngIf="Features.TtmTicketsDetailDelete | hasFeature" tabindex="3" matTooltip="Tickets" matTooltipPosition="after" [matBadge]="newTicketCount()" matBadgeColor="warn" [matBadgeHidden]="newTicketCount() === 0">
                <i class="fa fa-message-question"></i>
            </div>
            <div routerLink="/{{Routenames.Drawings}}" *ngIf="Features.DrawingsPaginated | hasFeature" tabindex="4" matTooltip="Tekeningen" matTooltipPosition="after">
                <i class="fa fa-draw-polygon"></i>
            </div>
            <div routerLink="/{{Routenames.Users}}" *ngIf="Features.UsersSave | hasFeature" tabindex="5" matTooltip="Gebruikersbeheer" matTooltipPosition="after">
                <i class="fa fa-people"></i>
            </div>
            <div routerLink="/{{Routenames.WorkOrders}}" *ngIf="Features.WorkordersPlanned | hasFeature" tabindex="6" matTooltip="Geplande werkopdrachten" matTooltipPosition="after">
                <i class="fa-solid fa-clipboard-list-check"></i>
            </div>
            <div routerLink="/{{Routenames.UserInsight}}" *ngIf="Features.AuthorisationLogPostCalls | hasFeature" tabindex="7" matTooltip="Statistieken" matTooltipPosition="after">
                <i class="fa fa-chart-simple"></i>
            </div>
            <div routerLink="/{{Routenames.AuthMatrix}}" *ngIf="Features.AuthRoles | hasFeature" tabindex="8" matTooltip="Rechtenmatrix" matTooltipPosition="after">
                <i class="fa fa-check-double"></i>
            </div>
        </div>


        <ng-container *ngFor="let project of projects">
            <map-marker
                *ngIf="project.center"
                (mapClick)="openProject(project)"
                [icon]="25 | tsnedMarker"
                [position]="project.center | geoLatLng"></map-marker>
        </ng-container>
    </google-map>
</div>
